import React from 'react';
import PropTypes from 'prop-types';
import {APARTMENTS, SALE} from '../../../../../consts';

function Area (props) {
  const item = props.item;
  const property = item.getProperty();
  const room = property.getRoom();
  const landPlot = property.getLandPlot();

  const totalArea = room.getTotalArea();
  const livingArea = room.getLivingArea();
  const kitchenArea = room.getKitchenArea();
  const landArea = landPlot.getTotalArea();

  const isApartments = props.item.getRealtyType() === APARTMENTS;

  const getLabel = (area) => {
    return (area && area.getLabel(false, false).replace('.0', '')) || '-';
  };

  const renderSaleApartmentArea = () => {
    return (
      <td className='paper col-area'>
        <span className='main-param'>
          { getLabel(totalArea) }/{ getLabel(livingArea) }/{ getLabel(kitchenArea) }
        </span>
      </td>
    );
  };

  const renderAreaDefault = () => {
    return (
      <td className='paper col-area'>
        { totalArea && (<div><span className='main-param'>{totalArea.getLabel(false)}</span></div>) }
        <div>
          {
            [
              (livingArea && livingArea.getLabel()),
              (kitchenArea && kitchenArea.getLabel()),
              (landArea && landArea.getLabel())
            ].filter(Boolean).map(el => <div key={el}>{el}</div>)
          }
        </div>
      </td>
    );
  };

  return isApartments ? renderSaleApartmentArea() : renderAreaDefault();
}

Area.propTypes = {
  item: PropTypes.object.isRequired
};

Area.defaultProps = {};

export default Area;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/PaperCells/Area.jsx